import GlobalStyles from "../styles/GlobalStyles";
import Hero from "../components/Hero";
import Services from "../components/Services";
import SuccessCases from "../components/SuccessCases";
import About from "../components/About";
import Newsletter from "../components/Newsletter";

function Home() {
  return (
    <>
      <GlobalStyles />
      <Hero />
      <About />
      <Services />
      <SuccessCases />
      <Newsletter />
    </>
  );
}

export default Home;
